<template>
    <SidePanel v-show="visible" :loading="loading" @close="handleClose">
        <template #header>
            <h3 class="mt-0 clearfix">
                {{ $l10n.__('Ajouter une remise TTC') }}
            </h3>
        </template>

        <template #content>
            <el-form
                ref="docBonusForm"
                labelPosition="top"
                :model="docBonus"
                :inlineMessage="true"
                labelWidth="120px"
            >
                <el-form-item
                    :label="$t.__('documents.DocBonusForm.discount')"
                    prop="bonus"
                    :error="errors.get('bonus')"
                >
                    <el-select v-model="docBonus.bonus" @change="changeBonus">
                        <el-option
                            v-for="option in bonuses"
                            :key="option.id"
                            :label="option.ref"
                            :value="option.id"
                        />
                    </el-select>
                </el-form-item>

                <div v-if="chosenBonus">
                    <el-form-item
                        :label="$t.__('common.labels.name')"
                        prop="name"
                        :error="errors.get('name')"
                    >
                        <el-input
                            v-model="chosenBonus.name"
                            :modelValue="chosenBonus.name"
                            readonly="readonly"
                            :disabled="true"
                        />
                    </el-form-item>

                    <el-form-item
                        :label="$t.__('common.labels.amount')"
                        prop="amount"
                        :error="errors.get('montant')"
                    >
                        <div class="flex-row">
                            <InputNumber
                                :key="docBonus.amount"
                                v-model="docBonus.amount"
                                :controls="false"
                                :precision="numberFormat.precision"
                                :separatorDecimal="numberFormat.decimal"
                                :separatorThousand="numberFormat.thousand"
                            />
                            <span
                                class="input-addon append ml-2"
                                style="
                                    height: 32px;
                                    box-sizing: border-box;
                                    padding-top: 10px;
                                    white-space: nowrap;
                                "
                            >
                                / {{ chosenBonus.formatted_unit }}
                            </span>
                        </div>
                    </el-form-item>
                </div>

                <el-form-item
                    :label="$t.__('common.labels.quantity')"
                    prop="qty"
                    :error="errors.get('qty')"
                >
                    <InputNumber
                        v-model="docBonus.qty"
                        :modelValue="docBonus.qty"
                        :controls="false"
                        :precision="numberFormat.precision"
                        :separatorDecimal="numberFormat.decimal"
                        :separatorThousand="numberFormat.thousand"
                    />
                </el-form-item>

                <div v-if="chosenBonus" class="form-group">
                    <label for="" class="form-label bold label-block">
                        {{ $l10n.__('Total') }}
                    </label>
                    <div class="form-input span_12">
                        <input
                            type="text"
                            class="span_12 h-4"
                            :value="$filters.numberFormat(totalBonus)"
                            readonly="readonly"
                            :disabled="true"
                        />
                    </div>
                </div>
            </el-form>
        </template>

        <template #footer>
            <CompassButton
                :label="$t.__('common.actions.save')"
                :disabled="docBonus.bonus == ''"
                @click.prevent="save"
            />
        </template>
    </SidePanel>
</template>
<script>
import InputNumber from 'vcomponents/utilities/InputNumber.vue';
import SidePanel from 'vcomponents/utilities/SidePanel.vue';
import { createNamespacedHelpers } from 'vuex';
import FormMixins from '../../mixins/FormMixins';
const { mapState } = createNamespacedHelpers('documentOverview');

export default {
    components: {
        InputNumber,
        SidePanel,
    },
    mixins: [FormMixins],
    data() {
        return {
            docBonus: {
                docid: this.docid,
                doctype: this.doctype,
                bonus: '',
                qty: 0,
                amount: 0,
            },
            bonuses: [],
            loading: true,
            numberFormat: {
                precision: parseInt(App.numformat.precision),
                decimal: App.numformat.decimals,
                thousand: App.numformat.thousands,
            },
            visible: false,
        };
    },
    created() {
        this.loadBonuses();
    },
    computed: {
        chosenBonus() {
            const index = _.findIndex(this.bonuses, { id: this.docBonus.bonus });
            if (index == -1) {
                return false;
            } else {
                this.docBonus.amount = this.bonuses[index].amount;

                return this.bonuses[index];
            }
        },

        totalBonus() {
            if (this.chosenBonus && this.docBonus.qty) {
                const unitAmount = this.docBonus.amount;
                const qty = NumberFormat.formatToFloat(this.docBonus.qty, App.numformat);
                return unitAmount * qty;
            }
            return 0;
        },

        ...mapState({
            docid: (state) => state.docid,
            doctype: (state) => state.doctype,
        }),
    },
    mounted() {
        this.visible = true;
    },
    methods: {
        handleClose() {
            this.visible = false;
            EventBus.emit('docBonusForm:close');
        },
        save() {
            this.loading = true;

            this.$ajax.post(
                `/rest/docbonus/link/${this.doctype}/${this.docid}`,
                {},
                this.docBonus,
                (response) => {
                    window.Utils.reload();
                },
                (error) => {
                    this.errors.setErrors(error.response.data.error.message);
                    this.loading = false;
                },
            );
        },

        loadBonuses() {
            this.$ajax.get(`/rest/bonus/all`, {}, (response) => {
                this.bonuses = response.bonusList;
                this.loading = false;
            });
        },
        changeBonus() {
            this.docBonus.amount = +_.cloneDeep(this.chosenBonus.amount);
        },
    },
};
</script>
